
import React from 'react';
import { Memory } from '@/types/memory';
import MemoryCard from './MemoryCard';
import { Skeleton } from '@/components/ui/skeleton';

interface MemoryGridProps {
  memories: Memory[];
  isLoading: boolean;
  userCanLike: boolean;
  onLikeToggle: () => void;
  onDeleteMemory?: () => void;
}

const MemoryGrid: React.FC<MemoryGridProps> = ({ 
  memories, 
  isLoading, 
  userCanLike,
  onLikeToggle,
  onDeleteMemory
}) => {
  if (isLoading) {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {Array(8).fill(null).map((_, index) => (
          <div key={index} className="mb-4">
            <Skeleton className="h-[300px] w-full rounded-md" />
            <div className="mt-2">
              <Skeleton className="h-4 w-3/4 mt-2" />
              <Skeleton className="h-4 w-1/2 mt-2" />
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (memories.length === 0) {
    return (
      <div className="text-center py-12">
        <h3 className="text-xl font-medium text-gray-500">No memories shared yet</h3>
        <p className="text-gray-400 mt-2">
          {userCanLike ? "Be the first to share a trip memory!" : "Trip members will add memories soon."}
        </p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 auto-rows-auto">
      {memories.map((memory) => (
        <MemoryCard 
          key={memory.id} 
          memory={memory} 
          userCanLike={userCanLike}
          onLikeToggle={onLikeToggle}
          onDelete={onDeleteMemory}
        />
      ))}
    </div>
  );
};

export default MemoryGrid;
